import React from "react";

import "./QuizzyClouds.scss";

function QuizzyClouds(props) {
  return (
    <div className="quizzy-clouds">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="199"
        height="105"
        viewBox="0 0 199 105"
      >
        <rect
          id="Rectangle_1537"
          data-name="Rectangle 1537"
          width="153"
          height="31"
          rx="15.5"
          transform="translate(46)"
          fill="#8358e8"
          opacity="0.27"
        />
        <rect
          id="Rectangle_1538"
          data-name="Rectangle 1538"
          width="199"
          height="31"
          rx="15.5"
          transform="translate(0 37)"
          fill="#8358e8"
          opacity="0.4"
        />
        <rect
          id="Rectangle_1539"
          data-name="Rectangle 1539"
          width="103"
          height="31"
          rx="15.5"
          transform="translate(0 74)"
          fill="#8358e8"
          opacity="0.7"
        />
      </svg>
    </div>
  );
}

export default QuizzyClouds;
